<template>
  <svg
    class="sonar-icon"
    :class="{'left': position == 'left', 'right': position == 'right', 'spinning': spinning == true, highlight : hasHighlight}"
    aria-hidden="true"
    focusable="false"
  >
    <use v-bind="{'xlink:href' : '/static/symbol-defs.svg#icon-' + iconRef + '-outline'}"></use>
  </svg>
</template>

<script>
export default {
  name: "base-icon",
  props: {
    iconRef: {
      default: "question-mark-circle",
      type: String
    },
    spinning: {
      default: false,
      type: Boolean
    },
    position: {
      default: "center",
      type: String
    },
    highlight: {
      type: String,
      default: "none"
    }
  },
  computed: {
    hasHighlight: function() {
      return this.highlight != "none";
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/base-components/base-icon.vue